
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'CancelAcceptedMonthly',
    props: {
        periodEndLabel: { type: String, default: '' },
        // What Stripe reported after the coupon was applied (coupon name or percent).
        discountLabel: { type: String, default: '' },
    },
    emits: ['done'],
});
